<template>
    <el-dialog
        :title="title"
        :width="$store.state.type == 'pc' ? (size ? '800px' : '500px') : '94%'"
        top="0"
        center
        :visible.sync="show">
        <div class="dialog_content">
            <!-- 自定义内容 -->
            <slot name="content" v-if="show"></slot>
        </div>
        <div class="act_box" slot="footer"  v-show="!['配对记录', '查看推送消息','关联工单列表'].includes(title)">
            <slot name="cancel_btn">
                <div class="button cancel" @click="show = false">
                    <span>取消</span>
                </div>
            </slot>
            <slot name="confirm_btn">
                <div class="button confirm" @click="dialogConfirm">
                    <span>确定</span>
                </div>
            </slot>
        </div>
    </el-dialog>
</template>
<script>
export default {
    name: 'gh-dialog',
    data() {
        return {
            show: false
        }
    },
    props: ['size', 'title', 'dialogBack'],
    methods: {
        dialogConfirm() {
            this.$emit('dialogBack');
        }
    }
}
</script>
<style scoped lang="less">
    /deep/ .el-dialog{
        border-radius: 24px;
        padding-bottom: 20px;
        .el-dialog__header{
            padding: 20px 0 10px 20px;
            font-weight: 600;
            line-height: 1.3;
            text-align: left;
            border-bottom: 1px solid @colorLine;
            .el-dialog__title{
                font-size: 16px;
            }
            
        }
        .el-dialog__body{
            padding: 40px 40px 10px;
            max-height: 450px;
            overflow-y: auto;
        }
        .button{
            margin: 0 10px;
        }
        .datetimerange{
            width: 100%!important;
        }
        @media (max-width: 768px) {
            border-radius: 12px;
            padding-bottom: 12px;
            .el-dialog__header{
                padding: 12px 0 8px 12px;
                font-weight: 600;
                line-height: 1.3;
                text-align: left;
                border-bottom: 1px solid @colorLine;
                .el-dialog__title{
                    font-size: 14px;
                }
                .el-dialog__headerbtn{
                    top: 14px;
                    right: 14px;
                }
            }
            .el-dialog__body{
                padding: 20px 10px 10px;
                max-height: 60vh;
                overflow-y: auto;
                .el-input__inner{
                    min-width: 0;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/dialog/gh-dialog.vue